import { TextRichText } from '$providers/Text';
import { IHeroSlide } from '$root/src/components';
import cn from 'classnames';
import { HTMLAttributes, useEffect, useState } from 'react';

export function Captions(props: IHeroSlide & HTMLAttributes<HTMLElement>) {
  const { num, richText, subTitle, currentPage } = props;

  const [animate, setAnimate] = useState(false);

  const returnLineBreaks = (text: string) => {
    if (text.includes('<br>')) {
      return text.split('<br>').map((innerText: any) => {
        return (
          <>
            {innerText}
            <br />
          </>
        );
      });
    } else {
      return text;
    }
  };

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setAnimate(currentPage === num);
      },
      currentPage === num ? 1500 : 0,
    );

    return () => clearTimeout(timer);
  });

  return (
    <div className={cn('relative')}>
      <div
        className={cn(
          'duration-[600ms]',
          animate
            ? 'translate-y-0 opacity-100'
            : 'translate-y-[200px] opacity-0',
        )}
      >
        {subTitle && (
          <h3
            className={cn(
              'pl-[2px] mt-2 md:mt-4 style-heading-xxs text-grey-80 dark:text-white',
            )}
          >
            {returnLineBreaks(subTitle)}
          </h3>
        )}
        {richText && (
          <div
            className={cn(
              'pr-4 md:pr-0 mb-4 md:mb-8 pl-[2px] mt-2 md:mt-4 style-body-l text-grey-80 dark:text-white',
            )}
          >
            <TextRichText className={'!style-body-l'} json={richText?.json} />
          </div>
        )}
      </div>
    </div>
  );
}
